import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Exploreindiapanindiacabbooking() {



const cardData = {
  keyword: " Explore India / Pan India Cab Booking Services",

headingDescription:
  "Omshree Cab offers comprehensive Explore India and Pan India cab booking services for travelers who want seamless, comfortable, and reliable transportation across major cities, states, and popular tourist circuits in India. Whether you are planning a long‑distance road trip, a cultural tour, a family vacation covering multiple states, a corporate travel itinerary, or a pilgrimage journey, our Pan India cab service ensures a hassle‑free travel experience with professional drivers and well‑maintained vehicles. We provide flexible booking options including one‑way interstate trips, round trips, multi‑day travel plans, and customized travel packages tailored to your itinerary, with transparent per‑kilometer pricing and no hidden charges. Our fleet includes air‑conditioned sedans, spacious SUVs, luxury cars, multi‑purpose vehicles (MPVs), and tempo travelers suitable for solo travelers, families, groups, and corporate clients. With easy online booking, experienced chauffeurs familiar with long‑distance and interstate routes, and 24/7 customer support, Omshree Cab makes exploring India by car comfortable, safe, and unforgettable.",

topPlaces: [
  {
    title: "Golden Triangle (Delhi–Agra–Jaipur)",
    description:
      "The Golden Triangle is one of India’s most famous travel circuits connecting New Delhi, Agra, and Jaipur. Visitors explore historic forts, magnificent palaces, UNESCO World Heritage Sites like the Taj Mahal, and vibrant markets that showcase India’s rich cultural heritage. A Pan India cab booking makes it convenient to cover all three destinations comfortably in a structured itinerary, with flexible stops, sightseeing breaks, and traveler‑friendly routes between the cities."
  },
  {
    title: "Goa Beach Circuit",
    description:
      "Goa is India’s top beach destination, known for its golden sands, vibrant nightlife, Portuguese heritage, and water sports. Travelers can explore popular beaches like Baga, Calangute, Palolem, and Anjuna, historic churches, spice plantations, and local markets. A Pan India cab allows tourists to travel leisurely between beaches and nearby hill stations or waterfalls while enjoying scenic road views and coastal drives, making it ideal for family vacations and group tours."
  },
  {
    title: "Kerala Backwaters & Hill Stations",
    description:
      "Kerala’s lush backwaters, serene houseboat experiences, tea and spice plantations, and hill stations like Munnar and Wayanad offer a peaceful and scenic getaway. Travelers can enjoy nature cruises, wildlife sanctuaries, waterfalls, and cultural experiences like Kathakali and local cuisine. Booking a Pan India cab lets you explore Kerala’s diverse landscapes without worrying about local transport, allowing you to customize your journey with convenient pick‑ups and drop‑offs."
  },
  {
    title: "Rajasthan Heritage Trail",
    description:
      "The Rajasthan Heritage Trail covers iconic destinations like Jaipur, Jodhpur, Udaipur, and Jaisalmer, each offering majestic forts, palaces, desert landscapes, and cultural heritage. Travelers can immerse themselves in royal architecture, desert safaris, traditional markets, and local cuisine. A Pan India cab service makes long‑distance travel between these cities comfortable, safe, and flexible, giving you time to enjoy the journey as much as the destinations."
  },
  {
    title: "Himachal Hills & Himalayan Routes",
    description:
      "Himachal Pradesh is home to scenic hill stations like Shimla, Manali, Dharamshala, and Dalhousie, offering cool climates, panoramic views, trekking trails, and mountain adventures. A Pan India cab service lets travelers experience winding mountain roads and valley vistas comfortably, making it perfect for honeymoon trips, nature getaways, and adventure travel without worrying about local commuting or frequent transfers."
  },
  {
    title: "Varanasi & Ganges Pilgrimage",
    description:
      "Varanasi, one of the oldest living cities in the world, holds immense spiritual significance on the banks of the Ganges River. Pilgrims and tourists visit for rituals, ghats, aarti ceremonies, and cultural experiences. A Pan India cab allows travelers to journey from gateway cities like Delhi or Mumbai to Varanasi with comfort, flexible stops, and ample sightseeing time along the way."
  },
  {
    title: "South India Temple Trail",
    description:
      "South India’s temple trail connects ancient and revered temple destinations like Tirupati, Madurai Meenakshi Temple, Rameswaram, and Kanchipuram. Travelers explore rich Dravidian architecture, spiritual heritage, and cultural festivals. A Pan India cab service makes this extensive itinerary practical and comfortable, enabling visits to multiple temples across states with customized travel plans."
  },
  {
    title: "Konkan Coast Drive",
    description:
      "The scenic Konkan Coast Drive stretches along the western coastline from Mumbai to Goa or Mangalore, featuring pristine beaches, forts, waterfalls, lush greenery, and local culinary hotspots. A Pan India cab allows travelers to enjoy coastal routes at their own pace, stopping at hidden gems and seaside towns while experiencing local culture and landscapes along the Arabian Sea."
  },
  {
    title: "North East India Beauty Trail",
    description:
      "The North East India Beauty Trail covers diverse and lesser‑explored destinations like Shillong, Kaziranga, Tawang, and Gangtok, known for breathtaking landscapes, wildlife sanctuaries, tribal culture, monasteries, and lakes. Booking a Pan India cab provides a comfortable mode of travel for this off‑beat yet enriching journey, with flexibility for route customization and local exploration."
  },
  {
    title: "Mumbai to Ladakh Highway Adventure",
    description:
      "The Mumbai to Ladakh highway adventure is a bucket‑list road trip that takes travelers through diverse terrains—from plains and deserts to high mountain passes like Khardung La. Visitors experience stark landscapes, crystal‑clear lakes like Pangong Tso, historic monasteries, and unique culture. A Pan India cab booking ensures a safe, comfortable, and well‑planned long‑distance journey across states, making it ideal for adventure enthusiasts and experienced road travelers."
  }
],



services: [
{
name: "Pan India Cab Service",
description: "Pan India cab service provides reliable transportation across major cities and destinations throughout India. Travelers can conveniently book vehicles for long-distance journeys, business trips, tourism, and pilgrimage travel. Professional drivers ensure safe driving and punctual pickup services from homes, offices, hotels, airports, and railway stations. The service covers major highways and intercity routes across multiple states. Ideal for tourists, corporate travelers, and families planning nationwide travel. Air-conditioned vehicles ensure comfortable journeys during long trips. Flexible booking options allow customers to plan travel easily anywhere in India."
},
{
name: "All India Cab Service",
description: "All India cab service offers comprehensive transportation solutions connecting cities, towns, and tourist destinations across the country. Travelers can hire comfortable vehicles for intercity travel, family vacations, and business journeys. Professional drivers ensure safe driving and reliable pickup services from airports, hotels, homes, and offices. The service supports long-distance travel across multiple states with experienced drivers familiar with national highways. Ideal for tourists, corporate clients, and pilgrims traveling across India. Comfortable vehicles ensure relaxed journeys during extended trips. Flexible booking options allow easy reservations anytime."
},
{
name: "India Tour Cab Service",
description: "India tour cab service provides convenient transportation for travelers exploring popular tourist destinations across the country. Vehicles are available for multi-day tours, sightseeing trips, and customized travel itineraries. Professional drivers ensure safe driving and knowledgeable assistance during travel across different regions of India. Pickup services are available from airports, hotels, and railway stations. Ideal for tourism circuits, cultural tours, and vacation travel. Spacious vehicles ensure comfortable journeys for families and groups. Flexible booking options allow travelers to plan tours according to their schedules."
},
{
name: "Long Distance Taxi India",
description: "Long distance taxi service in India offers comfortable transportation for travelers planning extended journeys between cities and states. Vehicles are well-maintained and suitable for highway travel across national routes. Professional drivers ensure safe driving and punctual pickup services from homes, hotels, offices, and airports. Ideal for interstate travel, family vacations, and corporate trips. Air-conditioned vehicles ensure comfortable travel during long hours on the road. Spacious seating and luggage space make travel convenient. Flexible booking options allow travelers to reserve taxis for long-distance journeys easily."
},
{
name: "Pan India Taxi Booking",
description: "Pan India taxi booking allows travelers to reserve taxis for journeys connecting multiple cities across the country. Online and phone booking options provide quick ride confirmation and easy travel planning. Professional drivers ensure punctual pickup and safe driving services across major Indian highways. Pickup services are available from airports, homes, hotels, and railway stations. Ideal for business travel, tourism, and long-distance trips. Comfortable vehicles ensure relaxed journeys for passengers. Flexible booking options make nationwide travel convenient and reliable."
},
{
name: "Intercity Cab India",
description: "Intercity cab service in India provides reliable transportation between major cities and regional destinations. Vehicles are suitable for long-distance highway travel and multi-city journeys. Professional drivers ensure safe driving and punctual pickup services across India. Pickup services are available from homes, offices, hotels, railway stations, and airports. Ideal for business travel, tourism visits, and family trips. Air-conditioned vehicles ensure comfortable journeys across long distances. Flexible booking options allow passengers to travel conveniently between cities."
},
{
name: "Outstation Cab India",
description: "Outstation cab service in India offers comfortable transportation for travelers planning trips outside their local city. Vehicles are well-maintained and suitable for interstate travel across national highways. Professional drivers ensure safe driving and punctual pickup services across India. Pickup services are available from homes, hotels, offices, airports, and railway stations. Ideal for weekend trips, family vacations, pilgrimage tours, and tourism travel. Spacious seating ensures comfortable journeys for passengers. Flexible one-way and round-trip booking options allow easy travel planning."
},
{
name: "India Travel Cab Service",
description: "India travel cab service provides convenient transportation solutions for tourists and travelers exploring different regions of the country. Vehicles are available for sightseeing tours, long-distance travel, and customized itineraries. Professional drivers ensure safe driving and reliable pickup services across India. Pickup services are available from airports, hotels, and railway stations. Ideal for tourism, cultural exploration, and family vacations. Comfortable vehicles ensure relaxed travel experiences. Flexible booking options allow travelers to plan journeys easily."
},
{
name: "Pan India Car Rental",
description: "Pan India car rental provides convenient vehicle hire services for travelers planning journeys across multiple cities in the country. Rental vehicles are suitable for long-distance travel, corporate trips, and tourism. Professional drivers ensure safe driving and punctual pickup services across India. Pickup services are available from airports, hotels, homes, and offices. Ideal for business travel, family vacations, and interstate journeys. Comfortable vehicles ensure relaxed travel experiences. Flexible rental options allow convenient nationwide travel planning."
},
{
name: "All India Taxi Service",
description: "All India taxi service provides reliable transportation connecting cities, tourist destinations, and pilgrimage sites across the country. Vehicles are well-maintained and suitable for long-distance highway travel. Professional drivers ensure safe driving and punctual pickup services across India. Pickup services are available from homes, hotels, airports, and railway stations. Ideal for tourism travel, business trips, and family vacations. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow convenient travel reservations."
},
{
name: "India Pilgrimage Cab Service",
description: "India pilgrimage cab service offers comfortable transportation for travelers visiting religious destinations across the country. Vehicles are suitable for long-distance journeys to temples, spiritual sites, and pilgrimage circuits. Professional drivers ensure safe driving and punctual pickup services across India. Pickup services are available from homes, hotels, airports, and railway stations. Ideal for temple tours, spiritual travel, and religious journeys. Spacious seating ensures comfortable travel for devotees and families. Flexible booking options allow easy pilgrimage planning."
},
{
name: "India Temple Tour Cab",
description: "India temple tour cab service provides reliable transportation for devotees visiting famous temples and spiritual destinations across the country. Vehicles are suitable for long-distance temple tours and pilgrimage routes. Professional drivers ensure safe driving and knowledgeable assistance during travel. Pickup services are available from homes, hotels, airports, and railway stations. Ideal for religious travel, temple circuits, and pilgrimage tours. Comfortable vehicles ensure relaxed journeys for devotees. Flexible booking options allow convenient temple tour planning."
},
{
name: "Pan India Cab Booking Online",
description: "Pan India cab booking online allows travelers to easily reserve taxis for journeys across multiple cities in India. Online booking platforms provide quick confirmations and convenient travel scheduling. Professional drivers ensure punctual pickup and safe driving services across national highways. Pickup services are available from airports, hotels, homes, and offices. Ideal for business travel, tourism visits, and long-distance journeys. Comfortable vehicles ensure relaxed travel experiences. Flexible booking options allow travelers to plan nationwide trips easily."
},
{
name: "India Road Trip Cab Service",
description: "India road trip cab service offers comfortable transportation for travelers planning scenic road journeys across different states and regions. Vehicles are suitable for long highway drives and multi-day travel itineraries. Professional drivers ensure safe driving and reliable navigation across national highways. Pickup services are available from homes, hotels, airports, and railway stations. Ideal for tourism road trips, family vacations, and adventure travel. Spacious vehicles ensure comfortable journeys during extended drives. Flexible booking options allow easy road trip planning."
},
{
name: "India Corporate Travel Cab",
description: "India corporate travel cab service provides reliable transportation solutions for business professionals traveling across multiple cities in the country. Vehicles are suitable for executive travel, conferences, and corporate meetings. Professional drivers ensure punctual pickup and safe driving services across India. Pickup services are available from offices, airports, hotels, and business centers. Ideal for executive travel, employee transportation, and corporate events. Comfortable vehicles ensure professional and relaxed journeys. Flexible booking options allow companies to plan nationwide business travel efficiently."
}
],

tableData: [
["Pan India Cab Service","All India Cab Service"],
["India Tour Cab Service","Long Distance Taxi India"],
["Pan India Taxi Booking","Intercity Cab India"],
["Outstation Cab India","India Travel Cab Service"],
["Pan India Car Rental","All India Taxi Service"],
["India Pilgrimage Cab Service","India Temple Tour Cab"],
["Pan India Cab Booking Online","India Road Trip Cab Service"],
["India Corporate Travel Cab","Nationwide Cab Service India"]
],



whychoose: [
  {
    WhyChooseheading: "Pan India Cab Network",
    WhyChoosedescription: "Omshree Cabs provides reliable Pan India cab booking services connecting major cities and tourist destinations across India. Travelers can easily book taxis for long-distance journeys, pilgrimage tours, corporate travel, and family vacations."
  },
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are experienced in interstate travel and long-distance routes across India. They are familiar with highways, state borders, toll systems, and major tourist circuits, ensuring safe and comfortable journeys."
  },
  {
    WhyChooseheading: "Transparent Nationwide Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Pan India cab bookings. Customers receive complete details about per-kilometer charges, toll fees, driver allowance, and travel packages before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Across India",
    WhyChoosedescription: "Our Pan India taxi service is available 24 hours a day. Whether you need a late-night airport pickup, early morning departure, or multi-day tour, Omshree Cabs ensures reliable travel anytime."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles",
    WhyChoosedescription: "We offer a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and group travelers."
  },
  {
    WhyChooseheading: "Ideal for Tours & Pilgrimage Travel",
    WhyChoosedescription: "Our Pan India cab services are perfect for pilgrimage tours like Char Dham Yatra, 12 Jyotirlinga Darshan, Ashtavinayak Yatra, and long-distance tourism across India."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Major Cities",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, railway stations, and airports in major cities like Mumbai, Pune, Delhi, Bangalore, Ahmedabad, Hyderabad, and more."
  },
  {
    WhyChooseheading: "Trusted Nationwide Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for safe and reliable Pan India cab services. Our professional drivers, comfortable vehicles, and responsive customer support ensure a smooth travel experience."
  }
]
};

const faqData = [
  { question: "Do you provide Pan India cab services?", answer: "Yes, Omshree Cabs provides nationwide taxi services across India for outstation travel, tours, and corporate transportation." },
  { question: "Which cities do you serve for Pan India travel?", answer: "We provide cab services connecting major cities such as Mumbai, Pune, Delhi, Bangalore, Hyderabad, Ahmedabad, Jaipur, Indore, and many other destinations." },
  { question: "Can I book a cab for multi-day tours across India?", answer: "Yes, customers can book cabs for multi-day tours and long-distance travel across India." },
  { question: "Which vehicles are available for Pan India travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers for group travel." },
  { question: "Is Pan India cab service available 24 hours?", answer: "Yes, our cab booking service operates 24/7 for nationwide travel." },
  { question: "Can I book cabs for pilgrimage tours?", answer: "Yes, we provide taxis for pilgrimage tours like 12 Jyotirlinga Yatra, Char Dham Yatra, and other spiritual travel routes." },
  { question: "Do you provide airport pickups in different cities?", answer: "Yes, we provide airport pickup and drop services in major cities across India." },
  { question: "Is advance booking recommended for long-distance travel?", answer: "Yes, advance booking is recommended for long-distance and multi-day travel to ensure vehicle availability." },
  { question: "Do you provide group travel vehicles?", answer: "Yes, we provide Tempo Travellers and mini buses for group travel across India." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ankit Sharma",
    feedback:
      "We booked Omshree Cabs for a multi-city tour across India. The driver was experienced and the journey was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Desai",
    feedback:
      "Excellent Pan India cab booking service. Professional driver, clean vehicle, and smooth long-distance travel experience.",
    rating: 5
  }
];
















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pan India Cab Booking Services",
  "description": "Omshree Cab offers Pan India cab booking services for long-distance travel, intercity trips, outstation journeys, corporate travel, pilgrimage tours, temple tours, and India road trips. Our fleet of well-maintained vehicles, experienced chauffeurs, and flexible booking options ensure safe, comfortable, and reliable travel across India.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1400"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Pan India Cab Booking Services | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides Pan India cab services for long-distance travel, intercity trips, outstation journeys, corporate travel, pilgrimage and temple tours, and India road trips. Well-maintained vehicles with experienced chauffeurs and flexible booking options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/56.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Exploreindiapanindiacabbooking;